<template>
  <div id="data-list-list-view" class="data-list-container">
    <popup-add-campaign ref="popupAddCampaign" />
    <h3>HQ Campaigns</h3>

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="mappedCampaigns"
      @selected="onClicked(selected)"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <div
            @click="showCampaignPopup"
            v-if="
              $AuthService.hasPermissionForActiveVenue(
                'vp.vp.activationplan.hqcampaigns.create'
              )
            "
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">New HQ Campaign</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                mappedCampaigns.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : mappedCampaigns.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Title</vs-th>
        <vs-th sort-key="date">Date</vs-th>
        <vs-th sort-key="category">Category</vs-th>
        <vs-th sort-key="starred">Starred</vs-th>
        <vs-th>Color</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.title }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ moment(new Date(tr.year, tr.month - 1)).format("MMMM yy") }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ tr.category }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ tr.starred ? "Yes" : "No" }}
              </p>
            </vs-td>

            <vs-td>
              <vs-chip :color="tr.color" class="product-order-status">
              </vs-chip>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="confirmDelete(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import moment from "moment";
import PopupAddCampaign from "./Popups/PopupAddCampaign.vue";

export default {
  components: {
    PopupAddCampaign,
  },
  data() {
    return {
      moment,
      query: "*",
      campaignToDelete: null,
      selected: null,
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  computed: {
    currentPage() {
      if (
        this.isMounted &&
        this.mappedCampaigns.length > 0 &&
        this.$refs.table
      ) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    mappedCampaigns: function () {
      console.log("Getting campaigns");
      const res = this.hqCampaigns();
      console.log("Campaigns result", res);
      return res ? res : [];
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.mappedCampaigns.length;
    },

    loading() {
      return (
        this.$store.state.venues.loading || this.$store.state.venues.allLoading
      );
    },
    ...mapGetters({
      me: "users/me",
      activeVenue: "venues/activeVenue",
      user: "users/user",
      hqCampaigns: "activationPlan/hqCampaigns",
    }),
  },
  methods: {
    showCampaignPopup() {
      const date = new Date();
      // Start date for campaign this month
      this.$refs.popupAddCampaign.show(
        date.getFullYear(),
        date.getMonth(),
        true
      );
    },
    confirmDelete(campaign) {
      this.campaignToDelete = campaign;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete the campaign for all the venues it is attached to?",
        accept: this.deleteCampaign,
      });
    },
    async deleteCampaign() {
      await this.$store.dispatch(
        "activationPlan/deleteCampaign",
        this.campaignToDelete.id,
        this.campaignToDelete.venueId
      );
      await this.$store.dispatch("getHQCampaign");
    },
    onClicked(campaignData) {
      if (
        !this.$AuthService.hasPermission(
          "vp.vp.activationplan.hqcampaigns.create"
        )
      )
        return;
      console.log("Clicked", campaignData, this.me);
      this.$refs.popupAddCampaign.showWith(
        campaignData,
        campaignData.year,
        campaignData.month
      );
      this.selected = null;
    },
  },
  created() {},
  mounted() {
    this.isMounted = true;
    this.$store.dispatch("activationPlan/getHQCampaigns");
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
